setTimeout(() => {
  var widget = document.getElementsByTagName('video')
  var btn = document.getElementsByClassName('vw-product-widget-btn')
  for (var i = 0; i < widget.length; i++) {
    widget[i].addEventListener('mouseover', mouseOver)
    widget[i].addEventListener('mouseout', mouseOut)
  }
  for (var i = 0; i < btn.length; i++) {
    btn[i].addEventListener('mouseover', mouseOver)
    btn[i].addEventListener('mouseout', mouseOut)
  }
}, 7000)
var cursor = document.getElementsByClassName('cur-Cursor')
function mouseOver () {
  for (var i = 0; i < cursor.length; i++) {
    cursor[i].style.display = 'none'
  }
}
function mouseOut () {
  for (var i = 0; i < cursor.length; i++) {
    cursor[i].style.display = 'block'
  }
}
